import { createAction } from 'redux-actions';

import { ADD_MESSAGE } from '../constants/Actions';

export default createAction(ADD_MESSAGE);
